module.exports = __webpack_public_path__ + "img/tarde_1@2x.babd68ec.jpg";